export const intro = (introRan, isHomepage) => {
  const introelement = document.getElementById("intro");
  const logoanimationelement = document.getElementsByClassName("js-logo-animation")[0];
  const logoelement = document.getElementsByClassName("js-logo")[0];
  const pushelement = document.getElementsByClassName("js-push")[0];

  const init = () => {
    if (introRan) {
      if (isHomepage == true) {
        introelement.style.display = "block";
      } else {
        introelement.style.display = "none";
      }
    }

    if (introRan == false) {
      bind();
    }

    pushelement.onclick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      // hideLogo();
      hideIntro();
    };
  };

  const showLogo = () => {
    logoelement.classList.add("fade-in");
  };

  const hideLogo = () => {
    logoelement.classList.add("fade-out");
  };

  const hideIntro = () => {
    // introelement.classList.add("fade-out");\
    introelement.classList.add("slide-out");
    pushelement.classList.add("push-out");
    document.body.setAttribute("data-intro-open", "false");
  };

  const bind = () => {
    // Do things related to intro
    // showLogo();
    setTimeout(showLogo, 100);
    logoanimationelement.classList.add("animate");
    // setTimeout(hideLogo, 2500);
    setTimeout(hideIntro, 2000);
  };

  if (typeof introelement != "undefined" && introelement != null) {
    init();
  }
};
